import React, { FC, useState } from 'react';

import {
  Stack,
  HStack,
  Text,
  Box,
  OrderedList,
  ListItem,
} from '@chakra-ui/react';
import { customTheme } from 'theme';

import { HelpCount } from 'components/DataDisplay/Utils/HelpCount';
import { CopyIcon } from 'components/Icons';
import { renderCopyIcon } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/OnboardGcp/utils';
import { CommandBox } from 'containers/Setup/CloudAccounts/CloudAccountWizard/Components/utils/CommandBox';

interface Props {
  command: string;
}

export const CreateServiceAccount: FC<Props> = props => {
  const { command } = props;
  const [copied, setCopied] = useState('');

  return (
    <Stack px={2} spacing={8} h="full">
      <Stack spacing={4}>
        <HStack align={'start'}>
          <HelpCount count={1} />
          <Text fontWeight={600}>
            Execute the following steps to setup Service Account
          </Text>
        </HStack>
        <OrderedList pl={8} color={customTheme.colors.gray['300']} spacing={2}>
          <ListItem pl={4}>
            Copy the command to create a service account for Ariksa
          </ListItem>
          <ListItem pl={4}>
            Use the redirect to login to your Google Cloud account
          </ListItem>
          <ListItem pl={4}>Open Cloudshell from your Google console</ListItem>
          <ListItem pl={4}>
            Paste the command in the Cloudshell to create the service account
          </ListItem>
        </OrderedList>
      </Stack>
      <Stack spacing={4}>
        <HStack align={'start'}>
          <HelpCount count={2} />
          <HStack>
            <Text fontWeight={600}>Command to create service account</Text>
            <Box color="primary">
              {renderCopyIcon(
                {
                  copyText: command,
                  icon: <CopyIcon p={0.5} color="primary" />,
                  tooltip: 'Copy command',
                },
                copied,
                setCopied,
              )}
            </Box>
          </HStack>
        </HStack>
        <Box pl={8}>
          <CommandBox>{command}</CommandBox>
        </Box>
      </Stack>
    </Stack>
  );
};
